import { connect } from 'react-redux';

import { createLine, updateLine } from '../actions/line';
import LineForm from '../components/LineForm';

const mapStateToProps = (state, ownProps) =>
  // const {
  //   match: {
  //     params: { id },
  //   },
  // } = ownProps;
  ({
    // location: ownProps.location,
    ...ownProps,
    obj: ownProps.line,
    // section: ownProps.section || (id ? state.song.sections.byId[id] : undefined),
  });
const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: (values) => {
    if (values) {
      if (values.id) {
        dispatch(updateLine({ ...values }));
      } else {
        dispatch(createLine(values));
      }
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LineForm);



// WEBPACK FOOTER //
// ./src/containers/LineFormContainer.js